const ZXS = [
  {
    path: "/orderManagement",
    name: "订单管理",
    icon: "el-icon-notebook-2",
  },
  {
    path: "/healthRecords",
    name: "健康档案",
    icon: "el-icon-folder-opened",
  },
  {
    path: "/earlyWarningManagement",
    name: "预警管理",
    icon: "el-icon-sunrise-1",
  },
  {
    path: "/teamMessage",
    name: "消息管理",
    icon: "el-icon-folder-opened",
  }
]
const TDD = [
  {
    path: "/HealManage",
    name: "健康师管理",
    icon: "el-icon-notebook-2",
  },
  {
    path: "/orderManagement",
    name: "订单管理",
    icon: "el-icon-notebook-2",
  },
  {
    path: "/healthRecords",
    name: "健康档案",
    icon: "el-icon-folder-opened",
  },
  {
    path: "/earlyWarningManagement",
    name: "预警管理",
    icon: "el-icon-sunrise-1",
  },
  {
    path: "/teamMessage",
    name: "消息管理",
    icon: "el-icon-folder-opened",
  }
];
const JGD = [
  {
    path: "/team",
    name: "团队管理",
    icon: "el-icon-notebook-2",
  },
  {
    path: "/HealManage",
    name: "健康师管理",
    icon: "el-icon-notebook-2",
  },
  {
    path: "/orderManagement",
    name: "订单管理",
    icon: "el-icon-notebook-2",
  },
  {
    path: "/healthRecords",
    name: "健康档案",
    icon: "el-icon-folder-opened",
  },
  {
    path: "/earlyWarningManagement",
    name: "预警管理",
    icon: "el-icon-sunrise-1",
  },
  {
    path: "/teamMessage",
    name: "消息管理",
    icon: "el-icon-folder-opened",
  },
  {
    path: "/role",
    name: "角色管理",
    icon: "el-icon-bank-card",
  },
  {
    path: "/user",
    name: "用户管理",
    icon: "el-icon-bank-card",
  },
  {
    path: "/menu",
    name: "菜单管理",
    icon: "el-icon-bank-card",
  }
];
const XTGLY = [
  {
    path: "/offlineAgencies",
    name: "线下机构管理",
    icon: "el-icon-office-building",
  },
  {
    path: "/team",
    name: "团队管理",
    icon: "el-icon-notebook-2",
  },
  {
    path: "/HealManage",
    name: "健康师管理",
    icon: "el-icon-notebook-2",
  },
  {
    path: "/orderManagement",
    name: "订单管理",
    icon: "el-icon-notebook-2",
  },
  {
    path: "/healthRecords",
    name: "健康档案",
    icon: "el-icon-folder-opened",
  },
  {
    path: "/earlyWarningManagement",
    name: "预警管理",
    icon: "el-icon-sunrise-1",
  },
  {
    path: "/teamMessage",
    name: "消息管理",
    icon: "el-icon-folder-opened",
  },
  {
    path: "/role",
    name: "角色管理",
    icon: "el-icon-bank-card",
  },
  {
    path: "/user",
    name: "用户管理",
    icon: "el-icon-bank-card",
  },
  {
    path: "/menu",
    name: "菜单管理",
    icon: "el-icon-bank-card",
  },
  {
    path: "/nutritionManagement",
    name: "营养素管理",
    icon: "el-icon-document",
  },
  {
    path: "/offlineServiceManagement",
    name: "线下服务管理",
    icon: "el-icon-s-shop",
  },
  {
    path: "/teamContact",
    name: "联系管理",
    icon: "el-icon-folder-opened",
  },
  {
    path: "/communityManagement",
    name: "社区管理",
    icon: "el-icon-s-home",
  }
];

// 根据角色获取导航列表
export const getMenuList = (role,roleE) => {
  console.log('2025 role:',role);
  if (role === roleE.ZXS) {
    return ZXS;
  } else if (role === roleE.TDD) {
    return TDD;
  } else if (role === roleE.JGD) {
    return JGD;
  } else if (role === roleE.XTGLY) {
    return XTGLY;
  } else if(role === roleE.CJYH){
    return XTGLY;
  }else{
    return [];
  }
};
